"use client";

import { createContext, useContext } from "react";

// The override map (original path -> replacement URL) is provided once at the root layout
// (server-read) and consumed by any client image component via useImageSrc(). Empty by default,
// so components used outside the provider (e.g. in the admin) render their original src safely.
const MediaOverrideContext = createContext<Record<string, string>>({});

export function MediaOverrideProvider({
  value,
  children,
}: {
  value: Record<string, string>;
  children: React.ReactNode;
}) {
  return (
    <MediaOverrideContext.Provider value={value}>
      {children}
    </MediaOverrideContext.Provider>
  );
}

/** Returns the replacement URL for a given image path if one has been set, else the original. */
export function useImageSrc(src: string): string {
  const map = useContext(MediaOverrideContext);
  return (src && map[src]) || src;
}
